import React, { useRef } from 'react';
import date from '@/endpoints/json/home.json';
import "./OfferZone.css";
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '@/assets/css/slick.css';
import { useLanguageContext } from '@/hooks/context-hooks';
import { OFFERZONE, OFFERRESULTS } from '@/_constant/urlconstants';
import { Link, useNavigate } from 'react-router-dom';
import megaphoneIcon from '@/assets/images/new/megaphone.png';

export default function OfferZone({ showPromoteLink = false }) {
  const { language } = useLanguageContext();
  const navigate = useNavigate();
  const sliderRef = useRef(null);

  const sliderSettings = {
    dots: false,
    arrows: false,
    infinite: false,
    speed: 500,
    autoplay: false,
    slidesToShow: 8.2,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 8.2
        }
      },
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 7.2
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 6.2
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4.2
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2.8
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2.2
        }
      }
    ],
  };

  const handleOfferZoneClick = (categoryId) => {
    navigate(OFFERRESULTS, { state: JSON.stringify({ categoryId: categoryId }) });
  };

  const getCategoryName = (url) => {
    try {
      const filename = url.split('/').pop();
      const cleanName = filename.split('.')[0].trim().toLowerCase();
      const translationKey = `category.${cleanName}`;
      const translated = language(translationKey);
      if (translated) {
        return translated;
      }
      return cleanName.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    } catch (e) {
      return 'Category Name';
    }
  };

  const offersData = date?.offers?.images || [];

  return (
    <section className="home-offerzone pt-4 pb-2">
      <div className="container-fluid px-4 px-md-5">

        {/* Section Header */}
        <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 px-1">
          <div className="offerzone-header-left ps-1">
            <div className="text-start">
              <h4 className="offerzone-title mb-1">
                {language("label.offer_zone") || "Offers Zone"}
              </h4>
              <p className="offerzone-subtitle mb-0">
                {language("label.offer_zone.subtitle") || "Exclusive offers across categories to help you grow your business & save more"}
              </p>
            </div>
          </div>

          <div className="offerzone-header-right d-flex align-items-center gap-3 mt-3 mt-md-0">
            {showPromoteLink && (
              <Link to="/post/create_post_OfferInformation" className="text-decoration-none">
                <div className="promote-banner-pill d-flex align-items-center px-4 py-2">
                  <div className="promote-icon-container me-2">
                    <img src={megaphoneIcon} alt="Promote" className="promote-icon" />
                  </div>
                  <div className="me-3 text-start">
                    <p className="promote-title mb-0">
                      {language('label.make_most_of_offers') || "Show your offers on our web and app"}
                    </p>
                    <p className="promote-subtitle mb-0">
                      {language('label.banner.run_your_ad_for_as_low') || "For as low as ₹500/month"}
                    </p>
                  </div>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 16" fill="none" className="promote-arrow ms-2">
                    <path d="M1.2002 8.05709H19.4859M19.4859 8.05709L12.4859 1.05709M19.4859 8.05709L12.4859 15.0571" stroke="#811EA2" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
              </Link>
            )}
          </div>
        </div>

        {/* Offers Slider Wrapper */}
        <div className="offer-slider-wrapper position-relative">


          {/* Offers Slider */}
          <div className="offer-slider-container pb-2">
            <Slider ref={sliderRef} {...sliderSettings}>
              {offersData.map((item, index) => (
                <div key={index} className="px-2 pb-2 h-100">
                  <div className="offer-card cursor-pointer d-flex flex-column h-100" onClick={() => handleOfferZoneClick(item.categorId)}>
                    <div className="offer-img-container position-relative">
                      <img src={item.url} alt="offer" />
                      {/* Green discount badge overlay */}
                      <div className="offer-discount-badge position-absolute d-flex align-items-center justify-content-center">
                        <span>Get upto 30% off</span>
                      </div>
                      <div className="offer-hover-overlay d-flex align-items-center justify-content-center">
                        <span className="explore-badge">Explore <i className="bi bi-arrow-right ms-1"></i></span>
                      </div>
                    </div>
                    <div className="offer-card-body p-2 bg-white d-flex flex-column justify-content-center text-center">
                      <h6 className="fw-bold text-black mb-0 text-truncate category-name">{getCategoryName(item.url)}</h6>
                    </div>
                  </div>
                </div>
              ))}

              {/* "See all Offers" slide */}
              <div className="px-2 pb-2 h-100">
                <div
                  className="see-all-card cursor-pointer d-flex flex-column justify-content-center align-items-center h-100"
                  onClick={() => navigate(OFFERZONE)}
                >
                  <div className="see-all-content text-center">
                    <h6 className="see-all-title mb-3">See all<br />Offers</h6>
                    <div className="see-all-btn-circle mx-auto">
                      <i className="bi bi-arrow-right text-white"></i>
                    </div>
                  </div>
                </div>
              </div>
            </Slider>
          </div>


        </div>

      </div>
    </section>
  );
}

